import React from 'react';
import fremtidensmad from '../../images/bill.jpg';

function FintechCard57() {
  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
      <div className="px-5 pt-5">
        <header>
          <h3 className="text-sm font-semibold text-gray-500 uppercase mb-1">
            <span className="text-gray-800 dark:text-gray-100">Bill Ackman</span>
          </h3>
        </header>
      </div>
      <div className="grow">
        <img src={fremtidensmad} alt="Fremtidens mad" className="w-full h-auto rounded-b-xl" />
      </div>
    </div>
  );
}

export default FintechCard57;